import React, { Component } from 'react'
import moment from 'moment';
import { css } from '@emotion/core';
import ClipLoader from 'react-spinners/ClipLoader';
import { Box } from 'grommet/components/Box';
import { ApiConfig } from '../Config.js';
import axios from 'axios';

export const logout = () => {
    sessionStorage.clear();

    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    if (process.env.NODE_ENV === 'development') {
        window.location.assign(window.location.origin + '/login');
    } else {
        window.location.assign(window.location.origin + '/oam/server/logout?end_url=' + window.location.origin + '/login');
    }

}

const LANDING_ALERT_EXPIRATION_DAYS = 30;
const LANDING_ALERT_EXPIRATION_MS = LANDING_ALERT_EXPIRATION_DAYS * 24 * 60 * 60 * 1000;

// Un valore precedente pari a "true" non contiene una data e viene quindi trattato come scaduto.
export const isLandingAlertVisible = (storageKey, expirationMs = LANDING_ALERT_EXPIRATION_MS) => {
    try {
        const dismissedAt = localStorage.getItem(storageKey);
        const dismissedAtTime = new Date(dismissedAt).getTime();

        return !dismissedAt || isNaN(dismissedAtTime) || (Date.now() - dismissedAtTime >= expirationMs);
    } catch (e) {
        return true;
    }
}

export const dismissLandingAlert = (storageKey) => {
    try {
        localStorage.setItem(storageKey, new Date().toISOString());
    } catch (e) {}
}

//const reg= `~!@#$%^&*()-_=+[]{}|;:,.<>/?'"`

//export const passwordRegex = /^.*(?=.{8,20})(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/ ])[a-zA-Z0-9~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/ ]+$|^.*(?=.{8,20})(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/ ])[a-zA-Z0-9~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/ ]+$|^.*(?=.{8,20})(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/ ])[a-zA-Z0-9~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/ ]+$|^.*(?=.{8,20})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/ ]+$/;
export const passwordRegex = /^.*(?=.{8,20})(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$^*_\-+=`|(){}[\]:;"'<>,.?/])[a-zA-Z0-9~!@#$^*_\-+=`|(){}[\]:;"'<>,.?/]+$|^.*(?=.{8,20})(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#$^*_\-+=`|(){}[\]:;"'<>,.?/])[a-zA-Z0-9~!@#$^*_\-+=`|(){}[\]:;"'<>,.?/]+$|^.*(?=.{8,20})(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$^*_\-+=`|(){}[\]:;"'<>,.?/])[a-zA-Z0-9~!@#$^*_\-+=`|(){}[\]:;"'<>,.?/]+$|^.*(?=.{8,20})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9~!@#$^*_\-+=`|(){}[\]:;"'<>,.?/]+$/;
export const usernameRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
export const number = /^\d+$/;
export const phoneNumber = /^\+(?:[0-9] ?){2,}[0-9]$/;
//export const emailRegex = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
export const emailRegex = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;

export const createCookie = (name, value, days) => {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    else {
        expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
}


export const dateConvert = (timestamp) => {
    var dateTimestamp = new Date(timestamp);
    var dateFormat = moment(dateTimestamp);
    var date = moment(dateFormat).format('DD-MM-YYYY');
    return date
}

export const formatAmount = (amount) => {
    return(new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(amount));
  }

export const maskCardNumber = (cardNumber) => {
    if (cardNumber === undefined || cardNumber === null) {
        return '';
    }

    const normalizedCardNumber = String(cardNumber).replace(/\s+/g, '');

    if (normalizedCardNumber.length === 0) {
        return '';
    }

    if (normalizedCardNumber.length <= 8) {
        return '*'.repeat(normalizedCardNumber.length);
    }

    const firstFourDigits = normalizedCardNumber.slice(0, 4);
    const lastFourDigits = normalizedCardNumber.slice(-4);
    const maskedMiddle = '*'.repeat(normalizedCardNumber.length - 8);
    const maskedGroups = maskedMiddle.match(/.{1,4}/g).join(' ');

    return `${firstFourDigits} ${maskedGroups} ${lastFourDigits}`;
}

export const loader = <ClipLoader
    css={css`margin: 0 auto;`} 
    sizeUnit={"px"}
    size={35}
    color={'#006FCF'}
    />;

export const noData = <Box style={{borderBottom: "1px solid #000000", borderTop: "1px solid #000000", padding: "20px 0"}}>
    Nessun risultato
</Box>

export var sessionExpired =  function (fn, er, token, ids, path) {
    //var token = sessionStorage.getItem('token');
    //var ids = sessionStorage.getItem('ids');
    //var path = window.location.href;
    console.log(path);
    var config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'MT_SESSION_ID': ids
        },
    };
    var data = {
        path: path
    };


    axios
        .post(ApiConfig.url.SESSION, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
        });
    
}

/////////////////////////////// Upload Component ///////////////////////////////
class AllegatiItem extends Component {
    
    constructor(){
        super();
        
        this.onDeleteItem = this.onDeleteItem.bind(this)  
    }  

    onDeleteItem(event) {
        this.props.deleteItem(this.props.id)
    }

    render() {
        // var fullPath = this.props.file;
        // if (fullPath) {
        //     var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
        //     var filename = fullPath.substring(startIndex);
        //     if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
        //         filename = filename.substring(1);
        //     }
           
        // }
     
    return (
        
        <div className="item" style={{marginTop:'10px'}}>
        <span> {this.props.file} </span> 
        <button className="buttonList" style={{float:'right'}} type="button" onClick={this.onDeleteItem}>X</button>
        </div>
    );
  }   
}

export class AllegatiList extends React.Component {

    render() {
    return (  
        <div>
        {this.props.items.map((item, index) => (
        <AllegatiItem file={item} id={index} key={item.file} deleteItem={this.props.deleteItem} />
        ))} 
    </div>
        
    );
  } 
}

